module.exports = __webpack_public_path__ + "static/media/pica-pau-chorao.63f8bd8b.mp3";